module.exports = __webpack_public_path__ + "85f341ad2c95ec6a94e41c5edb85a2ca.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/trumpet/10_A2.mp3
// module id = 109
// module chunks = 0